import { TrainingTrackElement, TrainingTrackElementType } from '../../../../../shared/src/trainingTrack.types';
import { TrackElement } from './TrackElement';
import { CheckpointElement } from './CheckpointElement';
import { TargetElement } from './TargetElement';
import { RampElement } from './RampElement';
import { ObstacleElement } from './ObstacleElement';
import { FireRingElement } from './FireRingElement';
import { BoosterElement } from './BoosterElement';
import { PowerUpElement } from './PowerUpElement';
import { TrackMarkerElement } from './TrackMarkerElement';

/**
 * Factory class for creating track elements
 */
export class TrackElementFactory {
    /**
     * Creates a track element based on its type
     * @param element The element data
     * @returns The created track element
     */
    public static createElement(element: TrainingTrackElement): TrackElement | null {
        switch (element.type) {
            case TrainingTrackElementType.CHECKPOINT:
                return new CheckpointElement(element);
            case TrainingTrackElementType.TARGET:
                return new TargetElement(element);
            case TrainingTrackElementType.RAMP:
                return new RampElement(element);
            case TrainingTrackElementType.OBSTACLE:
                return new ObstacleElement(element);
            case TrainingTrackElementType.FIRE_RING:
                return new FireRingElement(element);
            case TrainingTrackElementType.BOOSTER:
                return new BoosterElement(element);
            case TrainingTrackElementType.POWER_UP:
                return new PowerUpElement(element);
            case TrainingTrackElementType.TRACK_MARKER:
                return new TrackMarkerElement(element);
            default:
                console.warn(`[TrackElementFactory] Unknown element type: ${element.type}`);
                return null;
        }
    }
}